import BaseModel from "../base_model.js";

import { SignUpCompanyInfoModel } from "./sign_up_company_info_model.js";

import { InputLabelDisplayModeAbove } from "../../base/inputs/constants.js";

class RawSignUpCompanyModel extends BaseModel {

  rawFormFields(item = undefined) {
    return [
      {
        name: "personalInfo",
        type: "nestedModel",
        model: SignUpCompanyInfoModel
      },
      {
        name: "password",
        displayName: this.fieldDisplayName("password"),
        type: "password",
        displayNamePosition: InputLabelDisplayModeAbove
      }
    ]
  }

  i18nScope() {
    return "model.users.user";
  }

}
const SignUpCompanyModel = new RawSignUpCompanyModel();

export { RawSignUpCompanyModel, SignUpCompanyModel }
